enum AccountType {
  CARD_ISSUER = "CARD_ISSUER",
  BANK = "BANK", // External Connected Accounts
  ERP = "ERP",
  FINANCIAL_ACCOUNT = "FINANCIAL_ACCOUNT",
  REWARDS_ACCOUNT = "REWARDS_ACCOUNT",
  REWARDS_BANK = "REWARDS_BANK",
  REWARDS_BANK_ACCOUNT = "REWARDS_BANK_ACCOUNT",
  PLAID_EXTERNAL_CARD_ACCOUNT = "PLAID_EXTERNAL_CARD_ACCOUNT",
  PERSONAL_BANK = "PERSONAL_BANK",
  ASTRADA_EXTERNAL_CARD_ACCOUNT = "ASTRADA_EXTERNAL_CARD_ACCOUNT",
  ASTRADA_CONNECTION = "ASTRADA_CONNECTION",
  ASTRADA_BANK_CONNECTION = "ASTRADA_BANK_CONNECTION",
}

export default AccountType;
